export function transformUrl(link) {
  try {
    const url = new URL(link);

    // Проверяем, localhost ли
    if (url.hostname.includes("localhost")) {
      return link; // ничего не меняем
    }

    // Меняем путь
    let newPath = url.pathname.replace(/^\/?api\/\//, "/_server/public/");

    // Собираем новый URL
    return `${url.origin}${newPath}`;
  } catch (e) {
    return link; // если что-то пошло не так, вернём как есть
  }
}
